import React, { Component } from 'react';

export default class PrivacyPolicy extends Component {
	state = {
		operator: null, // Initialize operator state
	};

	componentDidMount() {
		const operator = JSON.parse(localStorage.getItem('op')); // Retrieve operator from localStorage
		this.setState({ operator }); // Store it in the state
		window.scrollTo(0, 0); // Scroll to the top of the page
	}

	render() {
		const { operator } = this.state; // Destructure operator from state

		return (

			<div className='content-container cancel-done-section pages-terms-and-conditions font10 newtnc newtncwidth'>
				<div className="cancel-ticket-done font20 page-title">
					Políticas<span className="bold-text">&nbsp;de privacidad</span>
				</div>
				<div
					className="terms-content font10"
					dangerouslySetInnerHTML={{ __html: operator && operator.privacy_policy }}  // Render the HTML content
				/>
			</div>

			// <div className="pages-privacy-policy content-container cancel-done-section font10">

			// 	<div className="cancel-ticket-done font20 page-title">
			// 		Políticas<span className="bold-text">&nbsp;de privacidad</span>
			// 	</div>

			// 	<div className="kupos-card contact-us-item">

			// 		<div className="mt-y-3 font13">
			// 			Términos<span className="bold-text">&nbsp;generales</span>
			// 		</div>
			// 		<div className="my-3 font10">
			// 			Las presentes políticas de privacidad (en adelante denominadas las “Políticas”) representan las condiciones de uso; políticas de privacidad y protección de datos en lo que refiere a la recolección y divulgación de información personal dentro de la plataforma ‘<span className="image-inside-text"><img src="/static/images/kupos_logo_2.png" alt="" /></span>’ y en la aplicación móvil para Android y iOS ‘<span className="image-inside-text"><img src="/static/images/kupos_logo_2.png" alt="" /></span>’; todas plataformas administradas, operadas, propiedad y responsabilidad de <b>PasajeBus SpA</b>.
			// 			<br /><br />
			// 			<b>PasajeBus SpA</b> se reserva el derecho de modificar las presentes Políticas sin previo aviso, con el fin de adaptarlas a novedades o requerimientos legislativos; actualización que será anunciada a través de las plataformas que conforman el Sitio Web.
			// 		</div>

			// 		<div className="number-and-text my-3">
			// 			<div className="secondary-circle">1</div>
			// 			<span><b>Aceptación de condiciones de uso</b>
			// 			</span>
			// 		</div>
			// 		<div className="privacy-sub-details">
			// 			<div className="number-and-text my-1">
			// 				<div className="primary-circle">a</div>
			// 				<span>La utilización y contratación de servicios a través de las plataformas de kupos.com y aplicaciones que conforman el Sitio Web, el usuario acepta y reconoce de su conocimiento y aceptación de las Políticas. Es responsabilidad del Usuario la lectura previa, entendimiento y aceptación de estas Políticas cada vez que sea utilizada cualquiera de las plataformas del Sitio Web.
			// 				</span>
			// 			</div>
			// 		</div>

			// 		<div className="number-and-text my-3">
			// 			<div className="secondary-circle">2</div>
			// 			<span><b>Identificación y autorización de usuarios</b>
			// 			</span>
			// 		</div>
			// 		<div className="privacy-sub-details">
			// 			<div className="number-and-text my-1">
			// 				<div className="primary-circle">a</div>
			// 				<span>Los servicios de kupos.com se dividen en dos grupos: Un primer grupo que no requiere registro de usuario obligatorio para su utilización y compra; y un segundo grupo que sí requiere registro de usuario obligatorio.
			// 				</span>
			// 			</div>
			// 			<div className="number-and-text my-1">
			// 				<div className="primary-circle">b</div>
			// 				<span>kupos.com ofrece al Usuario la facilidad de registrar una cuenta personal en el Sitio Web. Dicha Cuenta de usuario estará vinculada con su RUT o número de identificación, dirección de correo electrónico y número telefónico.
			// 				</span>
			// 			</div>
			// 			<div className="number-and-text my-1">
			// 				<div className="primary-circle">c</div>
			// 				<span>Es de exclusiva responsabilidad del Usuario el mantener la confidencialidad de su cuenta, su contraseña y de restringir el acceso a su ordenador o dispositivos con el fin de evitar accesos no autorizados a su Cuenta registrada. En caso de tener algún motivo para creer que su contraseña o cuenta está siendo utilizada por otra persona, es responsabilidad del Usuario el comunicarse e informar de manera inmediata al equipo de kupos.com. kupos.com no será responsable por pérdidas en las que el Usuario pueda incurrir debido a accesos o credenciales compartidas de su cuenta registrada.
			// 				</span>
			// 			</div>
			// 			<div className="number-and-text my-1">
			// 				<div className="primary-circle">d</div>
			// 				<span>El Usuario entiende y acepta que, al momento de registrar una Cuenta en kupos.com usando una cuenta personal (En adelante denominada la “Cuenta personal”) en cualquier red social, consiente expresamente que kupos.com (i) Tenga acceso, en cualquier momento, a la totalidad de la información contenida en su Cuenta personal, incluyendo pero no limitados a: sus Datos Personales, información sobre sus intereses, gustos, contactos y cualquier otro contenido alojado en su Cuenta personal; (ii) Incluya en dicha Cuenta personal mensajes, fotografías, videos y cualquier otro tipo de contenido; (iii) Envíe al correo electrónico del Usuario vinculado a la Cuenta Personal o al correo electrónico utilizado para realizar compras en kupos.com, información o mensajes relacionados a sus compras y transacciones dentro de las plataformas que conforman el Sitio Web.
			// 				</span>
			// 			</div>
			// 		</div>

			// 		<div className="number-and-text my-1">
			// 			<div className="secondary-circle">3</div>
			// 			<span><b>Recolección de datos</b>
			// 			</span>
			// 		</div>
			// 		<div className="privacy-sub-details">
			// 			{/* Additional detailed content remains unchanged */}
			// 		</div>
			// 	</div>
			// </div>

		);
	}
}



// WEBPACK FOOTER //
// ./src/features/pages/PrivacyPolicy.js